import { gql } from "@apollo/client";

export const CREATE_MASTER_DATA_RETAILER = gql`
  mutation CreateMasterDataRetailer($params: CreateMasterDataRetailerInput!) {
    createMasterDataRetailer(params: $params) {
      retailerId
      retailerKey
      retailerName
      matchRulesCount
      rawAssociationsCount
    }
  }
`;

export const UPDATE_MASTER_DATA_RETAILER = gql`
  mutation UpdateMasterDataRetailer($params: UpdateMasterDataRetailerInput!) {
    updateMasterDataRetailer(params: $params) {
      retailerId
      retailerKey
      retailerName
      matchRulesCount
      rawAssociationsCount
    }
  }
`;
